module.exports = __webpack_public_path__ + "img/mz_bg.e50846b0.png";